(function Index($, Adzuki)
{
	"use strict";
	var $modal = $(".modal");

	Adzuki.onload(['MarketingEfforts/index'], function onload() {
		$('.marketing-effort-summary').on('click', showMarketeingEffortSummary);
		loadTabsContent();

		$('body').on('ajax-pagination.loaded', function test() {
			$('#efforts .marketing-effort-summary').off();
			$('#efforts .marketing-effort-summary').on('click', showMarketeingEffortSummary);
			$('#archived-efforts .marketing-effort-summary').off();
			$('#archived-efforts .marketing-effort-summary').on('click', showMarketeingEffortSummary);
		});
	});

	$(document).ready(function documentReady() {
		Adzuki.onload('MarketingEffortAttachments/index/', function onload() {
			$('.task-details').off().on('click', _openTaskDetails);
		});

		Adzuki.onload(['MarketingEfforts/manageTasks/'], function onload() {
			Adzuki.TaskManager.loadEntityTasks('marketing_effort');
		});
	});

	function loadTabsContent()
	{
		Adzuki.Ajax.get('/MarketingEfforts/efforts/')
			.then(function populateMarketingEfforts(content) {
				$('#efforts').html(content);
				Adzuki.Form.initAjaxForm('MarketingEffortSort');
				$('#efforts .marketing-effort-summary').on('click', showMarketeingEffortSummary);
			}
		);

		Adzuki.Ajax.get('/MarketingEfforts/archive/')
			.then(function populateMarketingEffortArchives(content) {
				$('#archived-efforts').html(content);
				$('#archived-efforts .marketing-effort-summary').on('click', showMarketeingEffortSummary);
			}
		);
	}

	function showMarketeingEffortSummary(e) {
		var marketing_effort_id = $(this).data("id");

		e.preventDefault();

		$modal.find('.modal-title').text("Marketing Effort Summary");
		$modal.find('.modal-body').html('<i class="fa fa-spinner fa-spin fa-2x"></i>&nbsp;Loading...');
		$modal.modal('show');

		Adzuki.Ajax.get('/MarketingEfforts/summary/' + marketing_effort_id + '/1')
		.then(function success(data) {
			$modal.find('.modal-body').html(data);
		});
	}

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

}(jQuery, window.Adzuki || {}));
